<template>
  <div class="tools">
    <page-header titleName="TOOLS" />
    <div class="tools-content content">
      <div v-for="item in list" :key="item.id" class="tools-content-overview">
        <tool-overview v-bind="item" />
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from '../components/pageHeader'
import ToolOverview from '../components/toolOverview'
export default {
  title: 'Tools - α-Stella',
  components: { PageHeader, ToolOverview },
  data () {
    return {
      list: [
        {
          name: 'Wodistant（ウディスタント）',
          summary: 'ウディタ機能拡張ツール ( ウディタを使用している全ての方におすすめ )',
          releaseDate: '2018/07/21',
          updateDate: '2024/07/08',
          version: '1.4.0',
          imageFile: '/static/img/tools/overview/wodistant.png',
          linkButtonName: '特設サイト',
          link: './tool/wodistant/',
          description: [
            'ウディタの機能を外部から拡張して便利にするツールです。',
            `前回開いた複数のコモンを素早く開き直してイベントコマンドのスクロール状態も復帰したり、
            コメント文を素早く入力したり、コモンイベント同士の差分を比較することも可能です。`,
            '本ツールを使用して開発効率を向上させましょう！'
          ]
        },
        {
          name: 'WoditorOptimizer',
          summary: 'ウディタの処理を高速化するツール',
          releaseDate: '2015/04/18',
          updateDate: '2024/04/14',
          version: '2.1.1',
          imageFile: '/static/img/tools/overview/woditor_optimizer.png',
          linkButtonName: 'ダウンロード',
          link: 'https://alpha-stella.com/tool/woditor_optimizer/download/WoditorOptimizer_Ver2.1.1.zip',
          description: [
            'ウディタの『CommonEvnet.dat』を最適化して全コモンや任意のコモンを高速化できます。',
            `ゲームを公開する際に本ツールで最適化してから公開することでゲームの処理を軽くできます。
            ゲームが重くてユーザーの環境で快適に動くか心配な方にオススメです。`
          ]
        },
        {
          name: 'Woditoride',
          summary: 'ウディタ専用統合開発環境(エイプリルフール版)',
          releaseDate: '2018/04/01',
          updateDate: '2018/04/01',
          version: 'April Fool\'s Day Edition',
          imageFile: '/static/img/tools/overview/woditoride.png',
          linkButtonName: 'ダウンロード',
          link: 'https://ux.getuploader.com/k_shin07/download/32',
          description: [
            `ウディタより高機能なコモンイベントエディタを搭載！複数のコモンイベント同時に扱うことが可能です。
            また条件分岐の中身を閉じて見えないようにしたり、コモンイベント一覧にフィルタリングをかけたりできます。`,
            '※エイプリルフール企画として開発したものであるため編集機能はありません。閲覧専用です。'
          ]
        },
        {
          name: 'WodiKs',
          summary: 'ウディタツール開発用ライブラリ - α版',
          releaseDate: '2016/06/11',
          updateDate: '2016/06/11',
          version: '0.40α',
          imageFile: '/static/img/tools/overview/wodiks.png',
          linkButtonName: 'ダウンロード',
          link: 'https://ux.getuploader.com/k_shin07/download/29',
          description: [
            'ウディタ用のツール開発をサポートするライブラリです。(C#で作られています)',
            `ウディタが管理している『CommonEvent.dat』や『DataBase.dat』などを読み書きすることができます。
            本ツールはα版であるため不具合等を抱えている可能性がありますのでご注意ください。`,
            '※正式には非公開の最新版Ver0.96をひっそりと公開しているため欲しい方はK-Shin07までご連絡ください。非公開版はWodistant/Woditoride等で使用しているバージョンです。'
          ]
        },
        {
          name: 'WECDeletor',
          summary: 'ウディタのイベントコマンドから特定のコマンドを削除する',
          releaseDate: '2012/03/22',
          updateDate: '2012/11/03',
          version: '1.0.1',
          imageFile: '/static/img/tools/overview/wecdeletor.png',
          linkButtonName: 'ダウンロード',
          link: 'https://ux.getuploader.com/k_shin07/download/18',
          description: [
            '『WoditorOptimizer』の元となった古いツールです。',
            `イベントコマンドからコメント文,デバッグ文,チェックポイントなどのコマンドを削除できます。
            使用する際はウディタ上でイベントコードを取得し本ツールに貼り付けて実行してください。`,
            '※現在はサポートを終了しているため不具合等が発生したとしても対処はいたしません'
          ]
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import '../styles/definitions.scss';
.tools {
  &-content {
    background-color: $kContentColorMain;
    border-radius: 10px;
    margin: 50px auto 50px  auto;
    padding: 10px 0px 0px 0px;
    height: auto;
    color: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Tools.vue